import React from 'react';
import ReportLayout from 'src/pages/Reports/Common/report/ReportLayout';
import ReportDetails from 'src/pages/Reports/Common/report/ReportDetails';

const ConstructionReportDetails: React.FC = () => (
  <ReportLayout title="Building or Construction Report">
    <ReportDetails
      title="Report Details"
      downloadEndpoint="construction/report/download"
    />
  </ReportLayout>
);

export default ConstructionReportDetails;
